import React from "react";
import "./MovingKnowledge.scss"
import { AmsAccordion } from "components/accordion";
import { faqsData } from "components/amsLanding/faqs";
import { Button } from "components/button";

export interface MovingKnowledgeProps {
    onClick?(): void;
}

export interface MovingKnowledgeState {

}

class MovingKnowledge extends React.Component<MovingKnowledgeProps, MovingKnowledgeState> {
    constructor(props: MovingKnowledgeProps) {
        super(props);
        this.state = {};
    }
    getPrice() {
        if (this.props.onClick) {
            this.props.onClick()
            
        }
    }
    render() {
        return (
            <div style={{paddingBottom: "8em"}}>
            <div className="moving knowledge-container">
            <div className="title-fixed">
            <div className="moving knowledge-title">         
                 <h1>Moving Knowledge</h1>
                </div>
              <div className="moving knowledge-subtitle">
                    <h2>Learn more about your available pricing options. Call us to speak to one of our moving experts for more information.</h2>
                </div>
            </div>
                {/* FAQs */}
                <div className="faqs-scroll">
                <div className='faqs-container'>
                    <h2 className='faqs-heading'>FAQs</h2>
                    <AmsAccordion data={faqsData} expandByDefault={true}></AmsAccordion>
                    {/* <div className='help-text'>
                        <p>See more info in the <a href="https://www.affirm.com/help/" target="_blank" rel="noopener noreferrer">Help Center</a></p>
                    </div> */}
                </div>
                </div>
            </div>
             {/* <div className="pricing-btn">
             <Button
                 text={""}
                 onClick={() => this.getPrice()}
                 backgroundColor={"transparent"}
             />
         </div> */}
            </div>
        );
    }
}

export default MovingKnowledge;